import { api } from "@/lib/api";

export interface SearchHit {
  type: "ticket" | "customer" | "user" | "asset" | "product";
  id: string;
  primary: string;
  secondary: string;
  score: number;
}

export interface SearchResponse {
  query: string;
  total: number;
  groups: Record<string, SearchHit[]>;
}

export function globalSearch(q: string): Promise<SearchResponse> {
  return api.get<SearchResponse>(`/search?q=${encodeURIComponent(q)}`);
}
